import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { AllIcons } from 'shared/ui/app-icon/types'
import { PaymentType } from 'shared/ui/payment-type'

import { OpenMplusButton } from '../components/open-mplus-button'

import s from './styles.module.scss'

interface Props {
  onOpenMplus?: () => void
}

export const MplusNotAllowed: FC<Props> = ({ onOpenMplus }) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <PaymentType
        isActive
        icon={AllIcons.CASH}
        title={t('mplus.pay_current')}
        subTitle={t('mplus.with_trans_mbank')}
      />

      <OpenMplusButton onClick={onOpenMplus} />
    </div>
  )
}
